import Modal from "@components/modal";
import CopyInput from "@components/copy-input";
// import { useCallback, useState } from "react";
import { ICoinflipGame } from "@api/types/Coinflip";
import copy from "copy-to-clipboard";
import { ReactComponent as FairnessSvg } from "@assets/svg/fairness.svg";

import styles from "./FairnessModal.module.scss";

export default function FairnessModal({
  open,
  close,
  game,
}: {
  open: boolean;
  close: () => void;
  game: ICoinflipGame | null;
}): JSX.Element {
  const handleCopy = (text: any) => {
    console.log("copying:", text);
    copy(text as string);
  };
  if (!game) return <></>;

  return (
    <Modal {...{ isOpen: open, close }}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.icon}>
            <FairnessSvg />
          </span>
          <span className={styles.heading}>Coinflip Fair</span>
          <span className={styles.subheading}>Game #{game.roll}</span>
        </div>

        <CopyInput
          name="copy-input"
          readOnly
          label="Creator"
          value={game.game_metadata.creator.username}
          onCopy={() => {
            handleCopy(game.game_metadata.creator.username);
          }}
        />
        <CopyInput
          name="copy-input"
          readOnly
          label="Ticket Hash"
          value={game.ticket_hash}
          onCopy={() => {
            handleCopy(game.ticket_hash);
          }}
        />
        <CopyInput
          name="copy-input"
          readOnly
          label="Ticket ID"
          value={game.ticket_id}
          onCopy={() => {
            handleCopy(game.ticket_id);
          }}
        />
        <CopyInput
          name="copy-input"
          readOnly
          label="Ticket Verify URL"
          value={game.ticket_verify_url}
          onCopy={() => {
            handleCopy(game.ticket_verify_url);
          }}
        />
        <CopyInput
          name="copy-input"
          readOnly
          label="Roll Hash"
          value={game.uid}
          onCopy={() => {
            handleCopy(game.uid);
          }}
        />
        <CopyInput
          name="copy-input"
          readOnly
          label="Roll"
          value={game.roll}
          onCopy={() => {
            handleCopy(game.roll);
          }}
        />
      </div>
    </Modal>
  );
}
